var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoRanking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_1645_8721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0949 5.76349L17.85 3.32352C17.6442 2.89985 17.0007 2.88454 16.7738 3.32352L15.5289 5.76349L12.7701 6.14632C12.2795 6.21779 12.0685 6.80481 12.4325 7.15702L14.437 9.04569L13.9622 11.7051C13.8884 12.1799 14.3948 12.5474 14.8484 12.3279L17.3225 11.062L19.7806 12.3075C20.2343 12.527 20.746 12.1594 20.6669 11.6847L20.1921 9.02527L22.1966 7.15702C22.5553 6.80991 22.3496 6.22289 21.859 6.14632L19.1002 5.76349H19.0949ZM13.9359 16.0695C13.0022 16.0695 12.2478 16.7995 12.2478 17.703V27.5036C12.2478 28.4071 13.0022 29.1371 13.9359 29.1371H20.688C21.6217 29.1371 22.376 28.4071 22.376 27.5036V17.703C22.376 16.7995 21.6217 16.0695 20.688 16.0695H13.9359ZM2.11967 19.3364C1.18598 19.3364 0.431641 20.0664 0.431641 20.9699V27.5036C0.431641 28.4071 1.18598 29.1371 2.11967 29.1371H8.87177C9.80546 29.1371 10.5598 28.4071 10.5598 27.5036V20.9699C10.5598 20.0664 9.80546 19.3364 8.87177 19.3364H2.11967ZM24.064 24.2367V27.5036C24.064 28.4071 24.8184 29.1371 25.752 29.1371H32.5041C33.4378 29.1371 34.1922 28.4071 34.1922 27.5036V24.2367C34.1922 23.3332 33.4378 22.6033 32.5041 22.6033H25.752C24.8184 22.6033 24.064 23.3332 24.064 24.2367Z",
    fill: "url(#paint0_linear_1645_8721)",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1645_8721",
    x1: 36.1278,
    y1: 1.45495,
    x2: 30.741,
    y2: 34.1333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47297F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832A89"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1645_8721"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 33,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoRanking);
export default __webpack_public_path__ + "static/media/icono-ranking.c88512153ffb6fe677ae309b13f292f2.svg";
export { ForwardRef as ReactComponent };